import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import { ReactComponent as DistroIcon } from "shared/assets/images/icon-distro.svg";
import { ReactComponent as DiagnosticoIcon } from "shared/assets/images/icon-diagnostic.svg";
import { ReactComponent as RecomendacaoIcon } from "shared/assets/images/icon-recomendacao.svg";
import { ReactComponent as IconAdiantamentos } from "shared/assets/images/icon-wallet.svg";
import { ReactComponent as HomeIcon } from "shared/assets/images/icon-home.svg";
import { ReactComponent as QuincyIcon } from "shared/assets/images/quincy-icon.svg";
import { ReactComponent as IconMetas } from "shared/assets/images/icon-metas.svg";
import { ReactComponent as PitchinIcon } from "shared/assets/images/icon-pitching.svg";
import { ReactComponent as ReleasesScheduleIcon } from "shared/assets/images/release-schedule-icon.svg";
import { ReactComponent as IconStrmClass } from "shared/assets/images/icon-strm-class.svg";
import { ReactComponent as IconMenu } from "shared/assets/images/menu.svg";
import { ReactComponent as LevelMenu } from "shared/assets/images/icon-level.svg";
import { ReactComponent as PromotionIcon } from "shared/assets/images/icon-promotion.svg";
import { ReactComponent as TouringIcon } from "shared/assets/images/icon-touring.svg";
import { ReactComponent as AIAgentsIcon } from "shared/assets/images/icon-ai-agents.svg";
import { ReactComponent as HumanTeamIcon } from "shared/assets/images/icon-human-team.svg";
import { isEnableFullDiagnostic } from "shared/helpers/full-diagnostic-helpers";
import BadgeNew from "../badge-new/BadgeNew";
import { useFlags } from "launchdarkly-react-client-sdk";
import { dataLayerClickedEvent } from "event-tracker/gtm-events";
import { MenuButtonClickEventName } from "event-tracker/button-click-event-name";
import { ArtistState } from "explorer/reducers/artistas";
import { UserState } from "explorer/reducers/users";
import { DistributionStatusEnum } from "shared/enums/DistributionStatusEnum";
import MenuTag from "../subscription/MenuTag";
import { allowedTouringArtist } from "shared/helpers/touring-permissions";

interface ContentMenuProps {
  onCloseMenu?: () => void;
  fullScreen?: boolean;
}

const ContentMenu: React.FC<ContentMenuProps> = ({
  onCloseMenu = () => {},
  fullScreen,
}) => {
  const { t } = useTranslation();
  const { loggedUser } = useSelector((state: UserState) => state.users);
  const { userArtist, distroToken } = useSelector(
    (state: ArtistState) => state.artists
  );
  const acessoReleasePlanning = loggedUser?.isReleasePlanningEnable;

  const { showHome } = useFlags();
  const showTouring = allowedTouringArtist(userArtist?.country || "");
  const history = useHistory();

  const onClickDistro = () => {
    if (distroToken) {
      dataLayerClickedEvent(MenuButtonClickEventName.DISTRIBUTION, {
        businessContext: "MENU",
        platformContext: "S4A",
      });
      window.open(
        `${process.env.REACT_APP_REVELATOR_SITE}authorize?token=${distroToken}`,
        "_blank",
        "noopener,noreferrer"
      );
    } else {
      history.push("/distribua");
    }
    onCloseMenu();
  };

  const onClickMenuItem = (
    eventName?: keyof typeof MenuButtonClickEventName
  ) => {
    if (eventName && MenuButtonClickEventName[eventName]) {
      dataLayerClickedEvent(MenuButtonClickEventName[eventName] as any, {
        businessContext: "MENU",
        platformContext: "S4A",
      });
      onCloseMenu();
    }
  };

  return (
    <div
      className={`scroll-style mobile-menu-overlay${
        fullScreen ? " full-screen-menu" : ""
      }`}
    >
      <div className="full-menu-content">
        <div className="full-menu-section">
          <div className="section-title body-small">
            {t("components.MenuLateral.essentials")}
          </div>
          <div className="menu-grid">
            <Link
              to={showHome ? "/" : "/estagio"}
              className="menu-grid-item body-regular"
              onClick={() => onClickMenuItem(MenuButtonClickEventName.HOME)}
            >
              <HomeIcon className="icon" stroke="#bcb8f7" />
              <span className="label">Home</span>
            </Link>
            <Link
              to="/promotion"
              className="menu-grid-item body-regular"
              onClick={() =>
                onClickMenuItem(MenuButtonClickEventName.SONGTOOLS_MENU_CTA)
              }
              style={{ position: "relative" }}
            >
              {/* <BadgeNew
                text={t("pages.Home.new")}
                style={{ position: "absolute", top: 10, right: 6 }}
              /> */}
              <PromotionIcon className="icon" stroke="#bcb8f7" />
              <span className="label">
                {t("components.MenuLateral.promotion")}
              </span>
            </Link>
            {showHome && (
              <Link
                to="/estagio"
                className="menu-grid-item body-regular"
                onClick={() => onClickMenuItem(MenuButtonClickEventName.LEVEL)}
              >
                <LevelMenu className="icon" stroke="#bcb8f7" />
                <span className="label">
                  {t("components.MenuLateral.estagio")}
                </span>
              </Link>
            )}
            {isEnableFullDiagnostic(userArtist) && (
              <Link
                to="/diagnosticos"
                className="menu-grid-item body-regular"
                onClick={() =>
                  onClickMenuItem(MenuButtonClickEventName.ASSESSMENT)
                }
              >
                <DiagnosticoIcon className="icon" stroke="#bcb8f7" />
                <span className="label">
                  {t("components.MenuLateral.diagnostico")}
                </span>
              </Link>
            )}

            <Link
              to="/adiantamentos"
              className="menu-grid-item body-regular"
              onClick={() => onClickMenuItem(MenuButtonClickEventName.ADVANCES)}
            >
              <IconAdiantamentos className="icon" stroke="#bcb8f7" />
              <span className="label">Advances</span>
            </Link>
          </div>
        </div>
        <div className="full-menu-section">
          <div className="section-title body-small">
            {t("components.MenuLateral.acceleration")}
          </div>
          <div className="menu-grid">
            <Link
              to="/quincy"
              className="menu-grid-item body-regular"
              onClick={() => onClickMenuItem(MenuButtonClickEventName.QUINCY)}
            >
              <MenuTag variant="pro" />
              <QuincyIcon className="icon" fill="#bcb8f7" />
              <span className="label">Quincy</span>
            </Link>

            <Link
              to="/conexoes"
              className="menu-grid-item body-regular"
              onClick={() =>
                onClickMenuItem(MenuButtonClickEventName.CONNECTIONS)
              }
            >
              <MenuTag variant="pro" />
              <RecomendacaoIcon
                className="icon"
                fill="#bcb8f7"
                stroke="transparent"
              />
              <span className="label">
                {t("components.MenuLateral.recomendacoes")}
              </span>
            </Link>

            <Link
              to="/metas"
              className="menu-grid-item body-regular"
              onClick={() => onClickMenuItem(MenuButtonClickEventName.GOALS)}
            >
              <MenuTag variant="pro" />
              <IconMetas className="icon" stroke="#bcb8f7" />
              <span className="label">{t("components.MenuLateral.goals")}</span>
            </Link>

            <Link
              to="/strm-class"
              className="menu-grid-item body-regular"
              onClick={() =>
                onClickMenuItem(MenuButtonClickEventName.STRM_CLASS)
              }
            >
              <MenuTag variant="pro" />
              <IconStrmClass className="icon" stroke="#bcb8f7" />
              <span className="label">Strm Class</span>
            </Link>

            {showTouring && (
              <Link
                to="/touring"
                className="menu-grid-item body-regular"
                onClick={() =>
                  onClickMenuItem(MenuButtonClickEventName.TOURING)
                }
                style={{ position: "relative" }}
              >
                <BadgeNew
                  text={t("pages.Home.new")}
                  style={{ position: "absolute", top: 10, right: 6 }}
                />
                <TouringIcon className="icon" stroke="#bcb8f7" />
                <span className="label">
                  {t("components.MenuLateral.touring")}
                </span>
              </Link>
            )}
          </div>
        </div>
        <div className="full-menu-section">
          <div className="section-title body-small">
            {t("components.MenuLateral.smartDistribution")}
          </div>
          <div className="menu-grid">
            {(userArtist?.distribution?.available ||
              distroToken ||
              userArtist?.distribution?.status ===
                DistributionStatusEnum.Pending) && ( //essa condição é pq a distro fica available false se estiver como tentativa de fraude
              <button
                onClick={onClickDistro}
                className="menu-grid-item body-regular"
              >
                <MenuTag variant="stage" stageRestriction={4} />
                <DistroIcon className="icon" stroke="#bcb8f7" />
                <span className="label">
                  {t("components.MenuLateral.distro")}
                </span>
              </button>
            )}

            <Link
              to="/pitching"
              className="menu-grid-item body-regular"
              onClick={() => onClickMenuItem(MenuButtonClickEventName.PITCHING)}
            >
              <MenuTag variant="stage" stageRestriction={4} />
              <PitchinIcon className="icon" stroke="#bcb8f7" />
              <span className="label">
                {t("components.MenuLateral.pitching")}
              </span>
            </Link>
            <Link
              to={acessoReleasePlanning ? "/releases-schedule" : "#"}
              className="menu-grid-item body-regular"
              onClick={() =>
                acessoReleasePlanning &&
                onClickMenuItem(MenuButtonClickEventName.RELEASES)
              }
            >
              <MenuTag variant="stage" stageRestriction={4} />
              <ReleasesScheduleIcon
                className="icon"
                fill="#bcb8f7"
                stroke="transparent"
              />
              <span className="label">
                {t("components.MenuLateral.releasesSchedule")}
              </span>
            </Link>
            <Link
              to="#"
              className="menu-grid-item body-regular"
              role="button"
              style={{ display: "none" }}
            >
              <MenuTag variant="soon" />
              <AIAgentsIcon className="icon" stroke="#bcb8f7" />
              <span className="label">
                {t("components.MenuLateral.aiAgents")}
              </span>
            </Link>
          </div>
        </div>
        <div className="full-menu-section" style={{ display: "none" }}>
          <div className="section-title body-small">
            {t("components.MenuLateral.labelServices")}
          </div>
          <div className="menu-grid">
            <Link to="#" className="menu-grid-item body-regular" role="button">
              <MenuTag variant="soon" />
              <HumanTeamIcon className="icon" stroke="#bcb8f7" />
              <span className="label">
                {t("components.MenuLateral.humanTeam")}
              </span>
            </Link>
          </div>
        </div>
        {fullScreen && (
          <button
            className="close-btn full-menu-close"
            onClick={() => onClickMenuItem(MenuButtonClickEventName.OPEN_MENU)}
          >
            <IconMenu fill="#bcb8f7" />
          </button>
        )}
      </div>
    </div>
  );
};

export default ContentMenu;
